import React from 'react';
import {
  HStack,
  Text,
  Pressable,
  Icon,
} from '@gluestack-ui/themed';
import { Plus } from 'lucide-react-native';
import { useTranslation } from 'react-i18next';

interface AddTaskButtonProps {
  onPress: () => void;
  isReadonly?: boolean;
  isDisabled?: boolean;
}

const AddTaskButton: React.FC<AddTaskButtonProps> = ({
  onPress,
  isReadonly = false,
  isDisabled = false,
}) => {
  const { t } = useTranslation();

  if (isReadonly) return null;

  return (
    <Pressable
      onPress={onPress}
      disabled={isDisabled}
      p="$2"
      px="$3"
      mx="$4"
      my="$2"
      borderRadius="$md"
      borderWidth={1}
      borderStyle="dashed"
      borderColor="$borderLight"
      $hover={{ bg: '$bgHover' }}
      opacity={isDisabled ? 0.5 : 1}
    >
      <HStack alignItems="center" space="sm" justifyContent="center">
        <Icon as={Plus} size="xs" color="$brandBase" />
        <Text size="xs" fontWeight="semibold" color="$brandBase">
          {t('lecturer.moduleEditor.taskEditor.buttons.create')}
        </Text>
      </HStack>
    </Pressable>
  );
};

export default AddTaskButton;
